<iho-header />
<router-outlet></router-outlet>
<ng-container *ngIf="!isDatepickerOpen()">
      <iho-bottom-nav-mobile [userData]="userData()" />
</ng-container>
